import React from 'react';
import {
  ChakraAutocompleteField,
  ChakraAutocompleteFieldProps,
} from 'app/components/Core';
import { Option } from 'types/general.types';

interface SocietySelectProps {
  value: Option | null;
  isDisabled?: boolean;
  loading?: boolean;
}

export const SocietySelect = <Form extends {}>({
  value,
  ...props
}: SocietySelectProps & ChakraAutocompleteFieldProps<Form>) => (
  <ChakraAutocompleteField
    isClearable
    {...props}
    placeholder="Select Society"
    label={value ? 'Society' : ''}
    data-testid="Society"
    errorMessage=""
    isInvalid={false}
    autoFocus
  />
);
